import Messager from "./Messager";

const Root = (props) => (
    <div>
        <Messager/>
    </div>
);
export default Root;